import Product from './ProductNewController';

export default Product;
